import { render, staticRenderFns } from "./AppTeamLayout.vue?vue&type=template&id=38d62f71&"
import script from "./AppTeamLayout.vue?vue&type=script&lang=ts&"
export * from "./AppTeamLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports